export default __webpack_public_path__ + "img/favicon.7183ca21.ico";